import { DtoRequestExpensessPutReq } from "./abst/DtoRequestExpensessPutReq";
import { EntityRequest } from "../entity/EntityRequest";

export class DtoRequestExpensessPutReqImple extends DtoRequestExpensessPutReq {
  public request = new EntityRequest();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック

    return res;
  }
}
